import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41aeafa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("エアバッグコントローラの"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("バーコードを"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("読み込んでください")
  ])
], -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal"
  }, " YES ")
], -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("シリアル番号")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}, " YES ", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"serialOK\" tabindex=\"-1\" aria-hidden=\"true\" data-v-41aeafa0><div class=\"modal-dialog modal-dialog-centered\" data-v-41aeafa0><div class=\"modal-content\" data-v-41aeafa0><div class=\"modal-header\" data-v-41aeafa0><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-41aeafa0></button></div><div class=\"modal-body\" data-v-41aeafa0><p class=\"text-success fw-bold\" data-v-41aeafa0>OK品です。</p><p class=\"text-success fw-bold\" data-v-41aeafa0>車台番号を登録後、コントローラを車両に組付けてください</p></div><div class=\"modal-footer\" data-v-41aeafa0><button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\" data-v-41aeafa0> YES </button></div></div></div></div>", 1)
const _hoisted_17 = {
  class: "modal fade",
  id: "serialNG",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-41aeafa0><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-41aeafa0></button></div><div class=\"modal-body\" data-v-41aeafa0><p class=\"text-danger fw-bold\" data-v-41aeafa0>NG品です。</p><p class=\"text-danger fw-bold\" data-v-41aeafa0>このコントローラは使用せず、ほかのコントローラを使用してください。</p></div>", 2)
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5" }, [
  /*#__PURE__*/_createTextVNode("エアバッグコントローラの"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("バーコードを"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("読み込んでください")
], -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "再読み込み", -1 /* HOISTED */))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "rounded-3 mt-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "シリアル番号", -1 /* HOISTED */))
const _hoisted_30 = { class: "col-auto d-flex justify-content-center" }
const _hoisted_31 = { class: "d-flex justify-content-end" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "次へ", -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createCommentVNode(" モーダル "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          ($setup.serialFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, [
                    _hoisted_12,
                    _hoisted_13,
                    _createTextVNode(_toDisplayString($setup.serialNo), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.inputFix()))
                  }, " NO "),
                  _hoisted_15
                ])
              ]))
        ])
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.inputFix()))
            }, " YES ")
          ])
        ])
      ])
    ]),
    ($setup.ocrError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " もう一度バーコードを読み取ってください "))
      : _createCommentVNode("v-if", true),
    _hoisted_24,
    ($setup.videoFlag)
      ? (_openBlock(), _createBlock($setup["StreamBarcodeReader"], {
          key: 1,
          onDecode: _cache[2] || (_cache[2] = (a, b, c) => $setup.onDecode(a, b, c))
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary mt-3",
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.videoFlag = true))
    }, _hoisted_27),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _withDirectives(_createElementVNode("input", {
          id: "serialNo",
          type: "text",
          class: "form-control w-75 text-center",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.serialNo) = $event)),
          maxlength: "11"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.serialNo]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary mt-2",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.submitSerialNo()))
      }, _hoisted_33)
    ])
  ]))
}